import { useState } from 'react';

const useAddFirstZone = () => {
  const [addZoneForm, setAddZoneForm] = useState({
    delivery_country: '',
    deliver_state: '',
    shipping_rate_type: '',
    shipping_rate: '',
    exclusionary: false,
  });

  const [formErrors, setFormErrors] = useState<Partial<typeof addZoneForm>>({});

  const onValidate = () => {
    const errors: Partial<Partial<typeof addZoneForm>> = {};

    if (!addZoneForm.delivery_country) {
      errors.delivery_country = 'Field is Required';
    }

    if (!addZoneForm.deliver_state) {
      errors.deliver_state = 'Field is Required';
    }

    if (!addZoneForm.shipping_rate_type) {
      errors.shipping_rate_type = 'Field is Required';
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  return {
    addZoneForm,
    formErrors,
    setAddZoneForm,
    onValidate,
  };
};

export default useAddFirstZone;
